import eMulti from '../pages/IndicadoresAps/eMulti/Index.vue'

export default [
  {
    path: '/indicadores-aps/emulti',
    component: eMulti,
  },
  {
    path: '/indicadores-aps/emulti/media-atendimentos-por-pessoa',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eMulti/MediaAtendimentosPorPessoa/components/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-aps/emulti/media-atendimentos-por-pessoa',
        component: () =>
          import(
            '@/pages/IndicadoresAps/eMulti/MediaAtendimentosPorPessoa/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/indicadores-aps/emulti/acoes-interprofissionais',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eMulti/AcoesInterprofissionais/components/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-aps/emulti/acoes-interprofissionais',
        component: () =>
          import(
            '@/pages/IndicadoresAps/eMulti/AcoesInterprofissionais/Index.vue'
          ),
      },
    ],
  },
]
